export const HEADER = [
  {
    label: "",
    style: { width: "10%" },
  },
  {
    label: "company",
    style: { width: "20%", textAlign: "left" },
  },
  {
    label: "coach",
    style: { width: "30%", textAlign: "left" },
  },
  {
    label: "amount",
    style: { width: "20%", textAlign: "center" },
  },
  {
    label: "invoice date",
    style: { width: "20%", textAlign: "center" },
  },
];

export const ACTION_PAYMENT_TYPE = {
  SAVE: "save",
  INVOICE_SENT: "invoice sent",
  FINALIZE: "finalize",
};

export const INVOICE_STATUS = {
  DUE: "DUE",
  OVERDUE: "OVERDUE",
  PAID: "PAID",
};

export const PAYMENT_DURATION = 200;

export const PAYMENT_ACCOUNT_REQUEST_DELAY = 3000;

export const LOAD_PAYMENT_ACCOUNT_ERROR = "Failed to load the payment account";

export const CREATE_PAYMENT_ACCOUNT_FULFILLED =
  "We are trying to save your payment account. Please wait a little longer";

export const DELETE_PAYMENT_ACCOUNT_FULFILLED =
  "We are trying to delete your payment account. Please wait a little longer";

export const CREATE_PAYMENT_ACCOUNT_ERROR =
  "Failed to create the payment account";

export const DELETE_PAYMENT_ACCOUNT_ERROR =
  "Failed to delete the payment account";

export const CHECK_SESSION_ID_FULFILLED = "Your card is successfuly verified";

export const USER_TYPE_COMPANY_ADMIN = "CompanyAdmin";

export const INVOICE_AMOUNT_UPDATE =
  "The invoice amount has been updated. Please, try again";

export const UNKNOWN_FAIL = "Something went wrong. Please, try again";

export const PAYMENT_SUCCESS = "Payment has been made";

export const PAYMENT_DESCRIPTION_INVOICES_1 =
  "Your recomposer invoices will be emailed to you on the";
export const PAYMENT_DESCRIPTION_INVOICES_2 =
  "of each month and will be charged to your saved card 7 days \nlater.";
export const PAYMENT_DESCRIPTION_NOCARD_1 =
  "You have no saved credit card for payments. Your invoices are \ncurrently emailed to";
export const PAYMENT_DESCRIPTION_NOCARD_2 =
  "for payment by bank transfer. Enter a card below to switch to \nautomated payments:";
export const AGREE_CHARGE =
  "I agree to recomposer invoices being automatically charged to my \ncard above";

export const CURRENCY_MASK_OPTIONS = {
  prefix: "$",
  suffix: "",
  includeThousandsSeparator: false,
  allowDecimal: true,
  decimalSymbol: ".",
  decimalLimit: 2,
  integerLimit: 7,
  allowNegative: false,
  allowLeadingZeroes: false,
  inputMode: "numeric",
};

export const COMPANY_IDS_WITH_ACCESS_TO_PAY_NOW_FEATURE = [
  "61a622dca6070e25eb9cdbd6", // damon recomp
  "867f1f77bcf86cd799439011", // ernd era
  "62da4bffbc33461cc5825e99", // katrechko and co
];
